/*
 * Password-page behaviour — ported from the live coming-soon page
 * (~/Developer/oddmi-signup-page/index.html, the two <script> blocks at the end).
 *
 * Two jobs:
 *   1. Clone ticker items until the track is wide enough to loop seamlessly.
 *   2. POST the signup to the Cloudflare Pages Function that fronts EmailOctopus.
 *
 * Difference from the original: the endpoint is absolute and comes from the
 * section setting, because this page is served by Shopify while the Function
 * stays on Cloudflare. Everything else — the honeypot, the 8s watchdog, the
 * validation regex, the button states — matches the original's behaviour.
 */
(function () {
  'use strict';

  // ---- 1. Ticker ----------------------------------------------------------
  // Clone items until the track fills 3x the viewport, then scale the animation
  // duration so the scroll speed stays the same regardless of how many copies
  // it took. The keyframe travels -50%, so the track must be an even number of
  // copies for the loop to be seamless.
  function initTicker() {
    var track = document.querySelector('.odd-ticker__track');
    if (!track) return;

    var original = track.innerHTML;
    var origCount = track.children.length;
    if (!origCount) return;

    var guard = 0;
    while (track.scrollWidth < window.innerWidth * 3 && guard < 10) {
      track.innerHTML += original;
      guard++;
    }
    track.style.animationDuration = (track.children.length / origCount) * 22 + 's';
  }

  // ---- 2. Signup ----------------------------------------------------------
  function initSignup() {
    var wrap = document.querySelector('[data-odd-signup]');
    if (!wrap) return;

    var endpoint = wrap.getAttribute('data-endpoint');
    var input = wrap.querySelector('[data-odd-email]');
    var honeypot = wrap.querySelector('[data-odd-honeypot]');
    var btn = wrap.querySelector('[data-odd-submit]');
    var successMsg = wrap.querySelector('[data-odd-success]');
    var errorMsg = wrap.querySelector('[data-odd-error]');
    if (!input || !btn || !endpoint) return;

    var defaultLabel = btn.textContent;

    function handleSubmit() {
      var email = input.value.trim();

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        input.style.outline = '2px solid #f58a8c';
        input.style.borderRadius = '4px';
        setTimeout(function () {
          input.style.outline = '';
        }, 1200);
        return;
      }

      btn.textContent = 'Joining…';
      btn.disabled = true;
      if (errorMsg) errorMsg.classList.remove('is-shown');

      var settled = false;
      function finish(ok) {
        if (settled) return;
        settled = true;
        btn.textContent = defaultLabel;
        btn.disabled = false;
        if (ok) {
          input.value = '';
          if (successMsg) successMsg.classList.add('is-shown');
        } else if (errorMsg) {
          errorMsg.classList.add('is-shown');
        }
      }

      // Watchdog: never leave the button stuck if the network hangs.
      setTimeout(function () {
        finish(false);
      }, 8000);

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          website: honeypot ? honeypot.value : '',
          referrer: document.referrer,
        }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          finish(!!data && data.result === 'success');
        })
        .catch(function () {
          finish(false);
        });
    }

    btn.addEventListener('click', handleSubmit);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleSubmit();
      }
    });
  }

  // ---- 3. Scroll lock ------------------------------------------------------
  // details-modal.js locks scrolling with body.overflow-hidden, which on this
  // layout clips the page and resets scrollTop to 0 (see the note in
  // section-oddmi-password-hero.css). Mirror the open state onto <html>, where
  // overflow:hidden stops scrolling without moving the page.
  function initScrollLock() {
    var details = document.querySelector('.odd-nav details.password-modal');
    if (!details || !window.MutationObserver) return;

    var savedY = 0;
    var wasOpen = false;

    function sync() {
      var isOpen = details.hasAttribute('open');
      if (isOpen === wasOpen) return;

      if (isOpen) {
        savedY = window.scrollY;
        document.documentElement.classList.add('odd-modal-open');
      } else {
        document.documentElement.classList.remove('odd-modal-open');
        // Dawn's close() calls removeTrapFocus, which refocuses the toggle and
        // pulls the page back to the top. Measured: scroll went 120 -> 0 on
        // close even though opening preserved it. Put it back.
        if (window.scrollY !== savedY) window.scrollTo(0, savedY);
      }
      wasOpen = isOpen;
    }

    new MutationObserver(sync).observe(details, {
      attributes: true,
      attributeFilter: ['open'],
    });
    sync();
  }

  function init() {
    initTicker();
    initSignup();
    initScrollLock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
